import { initializeFilterPage } from "@/scripts/common/filter-page";

document.addEventListener("DOMContentLoaded", () => {
  initializeFilterPage(document.querySelector(".filter-form"));
});
